import type { SystemNotification } from "./types";

/** Совместимость gateway: принимает прямую cursor-page и обёрнутую data cursor-page. */
export function notificationItems(value: unknown): SystemNotification[] {
  if (typeof value !== "object" || value === null) return [];
  const first = (value as { data?: unknown }).data;
  if (Array.isArray(first)) return first as SystemNotification[];
  if (typeof first !== "object" || first === null) return [];
  const nested = (first as { data?: unknown }).data;
  return Array.isArray(nested) ? nested as SystemNotification[] : [];
}
